export default [
    {
        path: "sutarciu-generatorius",
        alias: ['generate-contract'],
        component: () =>
            import(
                /* webpackChunkName: "PublicTemplatesWrapper" */ "@/views/Contracts/ContractsWrapper.vue"
                ),
        meta: {
            layout: "Default",
        },
        children: [
            {
                path: ":slug/uzpildyti",
                alias: [':slug/fill'],
                name: "contract_fill",
                meta: {
                    breadcrumbs: ["templates_index", "template_index"],
                    hideTitle: true,
                    layout: "Generation",
                    sideMenuComponent: () =>
                        import(
                            "@/components/Contracts/ContractGeneration/QuestionSteps.vue"
                            ),
                },
                component: () =>
                    import(
                        /* webpackChunkName: "CreatePublicTemplate" */ "@/views/Public/Templates/CreatePublicTemplate.vue"
                        ),
            },
            {
                path: ":uuid",
                name: "contract_preview",
                meta: {
                    hideTitle: true,
                    layout: "OnboardingLayout",
                },
                component: () =>
                    import(
                        /* webpackChunkName: "PublicPreviewUserTemplate" */ "@/views/Public/Templates/PublicPreviewUserTemplate"
                        ),
            },
        ],
    },
];
